/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, color } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// VERTICAL BAR 1 STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	inner: {
		display: 'block',
		width: '100%',
		height: '100%',
		'& .bar': {
			background: color.greyMedium,
			transition: 'height .8s linear 0s, background .3s linear 0s'
		},
		'&.selected-true': {
			'& .bar.foreground': {
				background: color.brand
			},
			'&.correct-false': {
				'& .bar.foreground': { background: color.red }
			},
			'&.correct-true': {
				'& .bar.foreground': { background: color.green }
			}
		}
		// '&.selected-false': {
		// 	'&.finished-true': {
		// 		'&.correct-true': {
		// 			'& .bar.foreground': { transitionDelay: '2.0s', background: color.green },
		// 		}
		// 	}
		// }
	},
	bar: {
		borderRadius: replacePXinStringWithEM('7px 7px 0px 0px'),
		display: 'block',
		position: 'absolute',
		bottom: pxToEm(10),
		left: '50%',
		marginLeft: pxToEm(-25),
		width: pxToEm(50), //'100%', // modified in animations
		height: '0%' // dynamic, should come from component
	},
	number: {
		fontSize: pxToEm(14),
		position: 'absolute',
		bottom: pxToEm(-15),
		left: '0',
		textAlign: 'center',
		width: '100%'
	}
};
